import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ioteqVerticalNavigationComponent } from '@tools/components/navigation/vertical/vertical.component';
import { ioteqNavigationService } from '@tools/components/navigation/navigation.service';
import { ioteqNavigationItem } from '@tools/components/navigation/navigation.types';

@Component({
    selector       : 'ioteq-vertical-navigation-spacer-item',
    templateUrl    : './spacer.component.html',
    styles         : [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ioteqVerticalNavigationSpacerItemComponent implements OnInit, OnDestroy
{
    @Input() item: ioteqNavigationItem;
    @Input() name: string;

    private _ioteqVerticalNavigationComponent: ioteqVerticalNavigationComponent;
    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _ioteqNavigationService: ioteqNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._ioteqVerticalNavigationComponent = this._ioteqNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._ioteqVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
